// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6908":"c6600923","9827":"7f1c8554"}[chunkId] + ".chunk.css";
};